// src/reducers/groupReportReducer.js
import {
    FETCH_GROUP_REPORTS_SUCCESS,
    UPDATE_GROUP_REPORT_SUCCESS,
  } from '../actions/groupReportActions';
  
  const initialState = {
    groupReports: {},
  };
  
  const groupReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GROUP_REPORTS_SUCCESS:
        return {
          ...state,
          groupReports: action.payload.reduce((acc, report) => {
            acc[report.group_id] = report;
            return acc;
          }, {}),
        };
      case UPDATE_GROUP_REPORT_SUCCESS:
        return {
          ...state,
          groupReports: {
            ...state.groupReports,
            [action.payload.group_id]: action.payload,
          },
        };
      default:
        return state;
    }
  };
  
  export default groupReportReducer;
  